import type { ReactNode } from "react";

export function ChartCard({ title, testId, children }: { title: string; testId: string; children: ReactNode }) {
  return (
    <div
      className="flex flex-col gap-2 border border-sys-brand-outline rounded-lg p-4 h-full min-w-0"
      data-testid={testId}
    >
      <p className="text-title-medium text-sys-brand-on-surface m-0">{title}</p>
      <div className="w-full min-w-0">{children}</div>
    </div>
  );
}

export function EmptyChartMessage({ label }: { label: string }) {
  return (
    <div className="flex h-[225px] items-center justify-center">
      <p className="text-body-small text-sys-brand-on-surface-variant m-0 text-center">{label}</p>
    </div>
  );
}
